export default __webpack_public_path__ + "media/images/backgrounds/bg-08-1920x660-4cae0568e643a2af5875118203874a9d.jpg";